import { create } from 'zustand';

export type ModalStates = {
  feedbackUploadModal: boolean;
  customerUploadModal: boolean;
  attachmentModal: boolean;
  createFeedbackModal: boolean;
  companyUploadModal: boolean;
  tagConfigModal: boolean;
  searchFloatModal: boolean;
  navigatorFloatModal: boolean;
};

type Actions = {
  setModalStatus: (name: keyof ModalStates, status: boolean) => void;
  initModalStore: () => void;
};

const initialState: ModalStates = {
  feedbackUploadModal: false,
  customerUploadModal: false,
  attachmentModal: false,
  createFeedbackModal: false,
  companyUploadModal: false,
  tagConfigModal: false,
  searchFloatModal: false,
  navigatorFloatModal: false,
};

const useModalStore = create<ModalStates & Actions>((set) => ({
  ...initialState,
  setModalStatus(name, status) {
    set({ [name]: status });
  },
  initModalStore() {
    set(initialState);
  },
}));

export default useModalStore;
